import React from 'react';

const Statistics = () => {
  return (
    <main>
      <h2>Statistics About Homelessness</h2>
      
      <h3>Homelessness in the United States 2013</h3>
      <p>HOMELESS describes a person who lacks a fixed, regular, and adequate nighttime residence.</p>
      <ul>
        <li>Throughout the year in 2013 1.42 million people used shelter at some point</li>
        <li>1 in 3 are in CA or NY</li>
        <li>On a single night in January 2013 591,768 people were homeless</li>
      </ul>
      
      <h3>Homeless Individuals 2013</h3>
      <p>An INDIVIDUAL refers to a person in a household that does not have both an adult and a child. These households include people who are homeless alone, adult roommates, married or cohabiting couples without children, households comprised of multiple children (e.g., parenting teens), and unaccompanied youth.</p>
      <ul>
        <li>Throughout the year in 2013 943,017 individuals used shelter at some point</li>
        <li>Individuals in shelter were 2.3x more likely to be disabled than those in the U.S. population</li>
        <li>On a single night in January 2013 369,571 people were homeless as individuals</li>
      </ul>
    
      <h3>Homeless Families 2013</h3>
      <p>FAMILIES WITH CHILDREN are households composed of at least one adult and one child under age 18. Family households have various compositions: single-parent families, two-parent families, and multi-generation families.</p>
      <ul>
        <li>Throughout the year in 2013 495,714 people in families used shelter at some point</li>
        <li>About 3 in 5 homeless people in families were children</li>
        <li>On a single night in January 2013 222,197 people in families were homeless in 70,960 family households. About 36 percent of all homeless people on a single night were in families.</li>
      </ul>
      
      <p>All information gathered from <a href="https://www.hudexchange.info/">HUD Exchange</a></p>
  </main>
  );
}

export default Statistics;